
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire82b7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire82b7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("76Y9M", function(module, exports) {

$parcel$export(module.exports, "register", () => $52d7c1cea198bc9f$export$6503ec6e8aabbaf, (v) => $52d7c1cea198bc9f$export$6503ec6e8aabbaf = v);
var $52d7c1cea198bc9f$export$6503ec6e8aabbaf;
var $52d7c1cea198bc9f$export$f7ad0328861e2f03;
"use strict";
var $52d7c1cea198bc9f$var$mapping = new Map();
function $52d7c1cea198bc9f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$52d7c1cea198bc9f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $52d7c1cea198bc9f$var$resolve(id) {
    var resolved = $52d7c1cea198bc9f$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$52d7c1cea198bc9f$export$6503ec6e8aabbaf = $52d7c1cea198bc9f$var$register;
$52d7c1cea198bc9f$export$f7ad0328861e2f03 = $52d7c1cea198bc9f$var$resolve;

});

var $16724f4e10cb66a6$exports = {};

(parcelRequire("76Y9M")).register(new URL("", import.meta.url).toString(), JSON.parse('["aasnr","index.6c324557.js","2JMAA","devices.5e2bce36.ttl"]'));


//# sourceMappingURL=index.runtime.0dc0d2a3.js.map
